var _path, _path2, _rect, _g, _rect2, _rect3, _g2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 507,
    height: 308,
    viewBox: "0 0 507 308",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.91284 20.1142C4.91284 11.2146 12.4698 4 21.7919 4H485.121C494.443 4 502 11.2146 502 20.1142V287.61C502 296.51 494.443 303.724 485.121 303.724H21.7919C12.4698 303.724 4.91284 296.51 4.91284 287.61V20.1142Z",
    fill: "#FFEEE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7919 15.5844H485.121C487.877 15.5844 489.957 17.6952 489.957 20.1142V287.61C489.957 290.029 487.877 292.14 485.121 292.14H21.7919C19.0365 292.14 16.9561 290.029 16.9561 287.61V20.1142C16.9561 17.6952 19.0365 15.5844 21.7919 15.5844ZM21.7919 2.08413C11.4964 2.08413 2.99697 10.0737 2.99697 20.1142V287.61C2.99697 297.651 11.4964 305.64 21.7919 305.64H485.121C495.417 305.64 503.916 297.651 503.916 287.61V20.1142C503.916 10.0737 495.417 2.08413 485.121 2.08413H21.7919Z",
    fill: "white",
    stroke: "#FFEEE9",
    strokeWidth: 3.83174
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 416.762,
    y: 24.1423,
    width: 60.7645,
    height: 22.5599,
    rx: 4,
    fill: "#802A13"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4723_19933)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.3884,
    y: 24.1421,
    width: 60.7645,
    height: 22.5599,
    fill: "#802A13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.5862,
    y: 24.1421,
    width: 18.5669,
    height: 22.5599,
    fill: "#FF5326"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6418,
    y: 24.1421,
    width: 21.9427,
    height: 22.5599,
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 112.095,
    y: 24.1423,
    width: 269.22,
    height: 22.5599,
    rx: 4,
    fill: "#FFA993"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 112.095,
    y: 50.7307,
    width: 269.22,
    height: 8.05711,
    rx: 4,
    fill: "#FFA993"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 200.5,
    y: 156,
    width: 157,
    height: 20,
    rx: 4,
    fill: "#FFA993"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 199.5,
    y: 182,
    width: 157,
    height: 19,
    rx: 4,
    fill: "#FFA993"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 200.5,
    y: 207,
    width: 156,
    height: 20,
    rx: 4,
    fill: "#FFA993"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 200.5,
    y: 233,
    width: 156,
    height: 19,
    rx: 4,
    fill: "#FFA993"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 369.502,
    y: 233.085,
    width: 98.7423,
    height: 19.3371,
    rx: 4,
    fill: "#FFA993"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 200.5,
    y: 80,
    width: 94,
    height: 19,
    rx: 4,
    fill: "#FFA993"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 199.5,
    y: 120,
    width: 157,
    height: 20,
    rx: 4,
    fill: "#FFA993"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 370,
    y: 260.544,
    width: 86.083,
    height: 11.28,
    rx: 4,
    fill: "#FFA993"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102 243C142.041 243 174.5 210.541 174.5 170.5C174.5 130.459 142.041 98 102 98C61.9594 98 29.5 130.459 29.5 170.5C29.5 210.541 61.9594 243 102 243ZM95.75 188.625C95.1977 188.625 94.75 188.177 94.75 187.625V131.625C94.75 131.073 95.1977 130.625 95.75 130.625H106.945C107.497 130.625 107.945 131.073 107.945 131.625V187.625C107.945 188.177 107.497 188.625 106.945 188.625H95.75ZM95.75 212.695C95.1977 212.695 94.75 212.247 94.75 211.695V200.5C94.75 199.948 95.1977 199.5 95.75 199.5H106.945C107.497 199.5 107.945 199.948 107.945 200.5V211.695C107.945 212.247 107.497 212.695 106.945 212.695H95.75Z",
    fill: "#FF5326"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4723_19933"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.3884,
    y: 24.1421,
    width: 60.7647,
    height: 22.5599,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentWarning);
export default __webpack_public_path__ + "static/media/document_warning.e08875b9d6d1fdb35815357c847868ec.svg";
export { ForwardRef as ReactComponent };